// import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';
import headerNavDropdownHandler from './webActions/headerNavDropdownHandler';

export default (action) => {
  switch (action) {
    case 'hsExpand':
      return (props, e) => {
        e.preventDefault();
        CursorSpinner.pushToQueue('importHsExpand');
        import('./webActions/hsExpand').then((hsExpand) => {
          CursorSpinner.removeFromQueue('importHsExpand');
          hsExpand.default(props, e);
        });
      };
    case 'execute':
      return import('fg-frontend/src/partialUpdate/partialUpdate').then(module => module.execute);
    // case 'closeEsp':
    //   return import('fg-frontend/webActions/closeEsp');
    // case 'goBack':
    //   return import('fg-frontend/webActions/goBack');
    case 'scrollToHref':
      return import('fg-frontend/webActions/scrollToHref');
    // case 'passwordStrength':
    //   return import('fg-frontend/webActions/passwordStrength');
    // case 'confirmPopup':
    //   return import('fg-frontend/webActions/confirmPopup');
    case 'headerNavDropdownHandler':
      // return import('./webActions/headerNavDropdownHandler');
      return headerNavDropdownHandler;
    // case 'toggleClass':
    //   return import('fg-frontend/webActions/toggleClass');
    // case 'printPage':
    //   return import('fg-frontend/webActions/printPage');
    default:
      console.log('Unknown action');
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebActions.js